import { Pipe, PipeTransform } from "@angular/core";
import { Role } from "../enum/role";
import { UserStatus } from "../enum/userstatus";

@Pipe({
    name: "userStatus",
})
export class UserStatusPipe implements PipeTransform {
    transform(userStatus: UserStatus): string {
        switch (userStatus) {
            case UserStatus.Approved:
                return "Approved";
            case UserStatus.NotApproved:
                return "Not Approved";
            case UserStatus.UnderReview:
                return "Under Review";
            default:
                return "";
        }
    }
}
